import React from "react";
import ReactDOM from "react-dom";
import LeadsDSPrivate from "./screens/LeadsDSPrivate";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<LeadsDSPrivate />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about serv    ice workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
